export default {"src":"/_next/static/media/wincup-icon.f0feff10.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};